import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class SnackBarService {

  snackBarRef: MatSnackBarRef<any>;

  constructor(private snackbar: MatSnackBar) {}

  openSnackBar(message: string, action: string, duration: number) {
		this.snackBarRef = this.snackbar.open(message, action, {
			duration: duration,
		});
  }

}
